import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { usefulLinksRouteRef } from './routes';

export const usefulLinksPlugin = createPlugin({
  id: 'useful-links',
  routes: {
    usefulLinks: usefulLinksRouteRef,
  },
});

export const UsefulLinksPage = usefulLinksPlugin.provide(
  createRoutableExtension({
    name: 'UsefulLinksPage',
    component: () =>
      import('./components/UsefulLinksPage').then(m => m.UsefulLinksPage),
    mountPoint: usefulLinksRouteRef,
  }),
);
